
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/trademark-monitoring-report",
      function () {
        return require("private-next-pages/trademark-monitoring-report.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/trademark-monitoring-report"])
      });
    }
  